import { render } from "./SelectPage.vue?vue&type=template&id=2ea3f881"
import script from "./SelectPage.vue?vue&type=script&lang=js"
export * from "./SelectPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SelectPage.vue?vue&type=style&index=0&id=2ea3f881&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__